<rc-campaign-switcher [isDockable]="false" />